import {ThemeProvider} from '@primer/react-brand'

import {isFeatureEnabled} from '@github-ui/feature-flags'

import Hero from './components/sections/Hero/Hero'
import HeroOld from './components/sections/HeroOld/Hero'
import Features from './components/sections/Features/Features'
import FeaturesOld from './components/sections/Features/FeaturesOld'
import Testimonials from './components/sections/Testimonials/Testimonials'
import GetStarted from './components/sections/GetStarted/GetStarted'
import GetStartedOld from './components/sections/GetStarted/GetStartedOld'
import CtaBanner from './components/sections/CtaBanner/CtaBanner'
import AdditionalResources from './components/sections/AdditionalResources/AdditionalResources'
import AdditionalResourcesOld from './components/sections/AdditionalResources/AdditionalResourcesOld'
import Faq from './components/sections/Faq/Faq'
import FaqOld from './components/sections/Faq/FaqOld'

export default function CopilotExtensionsIndex() {
  return (
    <ThemeProvider
      colorMode="dark"
      className={`fp-hasFontSmoothing ${
        isFeatureEnabled('site_copilot_extensions_ga') ? 'site_copilot_extensions_ga' : ''
      }`}
    >
      {isFeatureEnabled('site_copilot_extensions_ga') ? <Hero /> : <HeroOld />}
      {isFeatureEnabled('site_copilot_extensions_ga') ? <Features /> : <FeaturesOld />}
      <Testimonials />
      {isFeatureEnabled('site_copilot_extensions_ga') ? <GetStarted /> : <GetStartedOld />}
      <CtaBanner />
      {isFeatureEnabled('site_copilot_extensions_ga') ? <AdditionalResources /> : <AdditionalResourcesOld />}
      {isFeatureEnabled('site_copilot_extensions_ga') ? <Faq /> : <FaqOld />}
    </ThemeProvider>
  )
}

try{ CopilotExtensionsIndex.displayName ||= 'CopilotExtensionsIndex' } catch {}